/*
 * A workspace whose inbox is switched off, at its own address (step 10, C4). The inbox is on for every
 * workspace unless switched off (Dawid's picker of 2026-10-18, question ledger `a3b2bc3c`), so this
 * is one someone chose to switch off: one sentence where the inbox would be, who can switch it on
 * (LeadCue does, through its operator path: `scripts/operations/inbox-access.ts`), and the way back
 * to this person's other inboxes (design review "Loading and empty", P2). For a person with the
 * reply agent, the workspace's own pages stay theirs there (the non-inbox rule in `route-access.ts`).
 * Nothing here asks an inbox route.
 */
import { useId } from "react";
import { useInboxAccess } from "./inbox-v2/use-inbox.ts";
import { AppLink, campaignsPath, inboxPath, settingsPath } from "./workspace-context.tsx";

type OtherWorkspace = {
  readonly id: string;
  readonly name: string;
  readonly inbox?: boolean | undefined;
};

export function InboxOff(props: { workspaceId: string; others: readonly OtherWorkspace[] }) {
  const agent = useInboxAccess(props.workspaceId).data?.replyAgent === true;
  const inboxes = props.others.filter((other) => other.inbox === true);
  const othersId = useId();
  return (
    <main className="lcr-inbox-off" aria-label="Inbox">
      {/* The shell's own "not available" page, in the same place and type. */}
      <div className="lcr-empty-detail lcr-unavailable">
        <h2>This workspace's inbox isn't switched on</h2>
        <p>Your LeadCue contact can switch it on.</p>
        {agent && (
          <nav className="lcr-inbox-off-links" aria-label="This workspace">
            <AppLink className="lcr-small-button" href={campaignsPath(props.workspaceId)}>
              Campaigns
            </AppLink>
            <AppLink className="lcr-small-button" href={settingsPath(props.workspaceId)}>
              Settings
            </AppLink>
          </nav>
        )}
        {inboxes.length > 0 && (
          <nav className="lcr-inbox-off-others" aria-labelledby={othersId}>
            <h3 id={othersId}>Your other inboxes</h3>
            <div className="lcr-inbox-off-links">
              {inboxes.map((other) => (
                <AppLink key={other.id} className="lcr-small-button" href={inboxPath(other.id)}>
                  {other.name}
                </AppLink>
              ))}
            </div>
          </nav>
        )}
      </div>
    </main>
  );
}
